import * as React from 'react';
import { Box } from 'wix-style-react';
import { getLogoUrl } from '../../DocParts/Logo/getLogoUrl';
export var Logo = function (_a) {
    var _b = _a.onImageReady, onImageReady = _b === void 0 ? function () { } : _b, logo = _a.logo;
    var hasLogo = function () { return logo && logo.match(/(?:[^\/]+)$/); };
    var handleLogoNotExist = function () {
        onImageReady();
        return React.createElement(Box, null);
    };
    return hasLogo() ? (React.createElement(Box, { dataHook: "business-logo" },
        React.createElement("img", { style: {
                maxHeight: '90px',
                maxWidth: '167px',
                width: 'auto',
                height: 'auto',
                position: 'relative',
            }, decoding: "sync", src: getLogoUrl(logo, { maxWidth: 622, maxHeight: 200 }), onError: function (_a) {
                var image = _a.target;
                image.parentElement.style.display = 'none';
                onImageReady();
            }, onLoad: onImageReady }))) : (handleLogoNotExist());
};
//# sourceMappingURL=Logo.js.map